import { ITime } from 'models/timeForm/timeForm.model';
import { createContext, useContext } from 'react';

interface ITimeFormContext {
	states: {
		editTimeForm: ITime | undefined;
		resetBreakForm: boolean;
	};
	setters: {
		setEditTimeForm: (lancamento: ITime | undefined) => void;
		setResetBreakForm: (value: boolean) => void;
	};
}

export const TimeContext = createContext({} as ITimeFormContext);

export const useTimeFormContext = () => useContext(TimeContext);
